<template>
  <div class="page-container">
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item>
        公告录入
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <el-select
          :value="categoryId"
          @change="handleCategoryChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in categoryOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          :value="language"
          @change="handleLanguageChange"
          placeholder="请选择"
        >
          <el-option
            v-for="item in languageOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input placeholder="请输入搜索内容" v-model="query" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <create-announcemnet @onCreated="refreshList"></create-announcemnet>
        <announcement-categories></announcement-categories>
      </div>
      <el-table :data="announcementList">
        <el-table-column prop="__category" label="分类"> </el-table-column>
        <el-table-column prop="__language" label="语言类型"> </el-table-column>
        <el-table-column prop="title" label="标题"> </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.__status.color">{{
              scope.row.__status.text
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 0"
              type="success"
              icon="el-icon-upload"
              circle
              size="small"
              @click="handlePublish(scope.row)"
            ></el-button>
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="handleUpdate(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handlePageChanged"
      >
      </pagination>
    </el-card>
    <update-announcement @onUpdated="refreshList"></update-announcement>
  </div>
</template>

<script>
import './store';
import CreateAnnouncemnet from './components/create';
import UpdateAnnouncement from './components/update';
import AnnouncementCategories from './components/categories';
import Pagination from 'components/pagination';
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import { PAGINATION } from './constants';

export default {
  name: 'Announcement',
  data() {
    return {
      categoryId: null,
      language: null,
      status: null,
      query: ''
    };
  },
  components: {
    CreateAnnouncemnet,
    UpdateAnnouncement,
    AnnouncementCategories,
    Pagination
  },
  methods: {
    ...mapActions('announcement', ['list', 'remove', 'search', 'publish']),
    ...mapMutations('announcement', [
      'setAnnouncementDetailDialogVisible',
      'setAnnouncementDetail'
    ]),
    handleCategoryChange(categoryId) {
      this.categoryId = categoryId;
      this.query = '';
      this.refreshList({ page: 1 });
    },
    handleLanguageChange(lang) {
      this.language = lang;
      this.query = '';
      this.refreshList({ page: 1 });
    },
    handleUpdate(selected) {
      this.setAnnouncementDetail(selected);
      this.setAnnouncementDetailDialogVisible(true);
    },
    handleRemove(selected) {
      this.$confirm('确定删除该公告吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(selected.id).then(() => {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.refreshList({ page: 1 });
    },
    refreshList(data = {}) {
      this.list({
        categoryId: this.categoryId,
        query: this.query,
        language: this.language,
        status: this.status,
        ...this.pagination,
        ...data
      });
    },
    handlePublish(selected) {
      this.$confirm('确定要发布该公告吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.publish(selected.id).then(() => {
          this.$message.success('发布成功！');
          this.refreshList();
        });
      });
    },
    handlePageChanged(pagination) {
      this.refreshList(pagination);
    }
  },
  computed: {
    ...mapGetters('announcement', ['announcementList', 'categoryList']),
    ...mapState('announcement', ['totalCount', 'pagination', 'languageList']),
    categoryOptions() {
      return [{ label: '所有分类', value: null }, ...this.categoryList];
    },
    languageOptions() {
      return [{ label: '所有语言', value: null }, ...this.languageList];
    }
  },
  created() {
    this.list({
      categoryId: this.categoryId,
      query: this.query,
      ...PAGINATION,
      language: this.language,
      status: this.status
    });
  }
};
</script>

<style lang="less" scoped></style>
